<div *ngIf="isVisible" class="searchBar-flex">
    <div class="searchBar">
      <mat-form-field class="width-input">
        <input
          #filterGlobal
          [(ngModel)]="globalFinder"
          matInput
          placeholder="Búsqueda por Identificador"
          spellcheck="false"
          type="text"
          (keyup.enter)="onGlobalFilter(filterGlobal.value)"
          [matAutocomplete]="auto"
        />
      </mat-form-field>
    </div>
    <div class="btnSearch-container" (click)="onGlobalFilter(filterGlobal.value)">
      <img class="btnSearchIcon" src="/assets/img/icon_search.png" width="25px">
    </div>
  </div>